import {
    ButtonPrimary,
    ButtonSecondary,
    Input,
    ModalBase,
    Textarea,
} from 'pac-ux-components';
import React from 'react';

function EditPacProductModal({product, handleSave, closeModal, display}) {
    const [saving, setSaving] = React.useState(false);
    const [pacProduct, setPacProduct] = React.useState({
        id: product.id,
        name: product.name,
        clientId: product.clientId,
        ourPrivateKey: '',
        theirPublicKey: product.theirPublicKeyValue ?? '',
        ourPublicKey: product.ourPublicKeyValue ?? '',
        clientSecret: '',
    });

    return (<div style={{display: 'flex', flexDirection: 'column', gap: 12}}>
        <ModalBase
            style={{display: (display === true) ? 'block' : 'none'}}
        >

            <form
                onSubmit={async (e) => {
                    e.preventDefault();
                    setSaving(true);
                    await handleSave(pacProduct, 'PUT');
                    e.stopPropagation();
                    return;
                }}
            >
                <div style={{
                    width: '619px',
                    paddingLeft: 33,
                    fontFamily: 'Inter',
                    maxHeight: '70vh',
                    overflowY: 'auto',
                }}>
                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 24,
                        fontWeight: '700',
                        marginTop: 38,
                        marginBottom: 32,
                        wordWrap: 'break-word',
                    }}>Edit PAC Product
                    </div>


                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                        marginTop: 12,
                    }}>PAC Product ID
                    </div>
                    <div style={{
                        width: '100%',
                        color: '#7A7A7A',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                        marginTop: 8,
                    }}>{product.id}
                    </div>

                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                        marginTop: 22,
                    }}>PAC Product Name
                    </div>
                    <Input value={pacProduct.name}
                           onChange={(e) => {
                               setPacProduct({
                                   ...pacProduct, name: e.target.value,
                               });
                           }}
                           required={true}
                           style={{
                               background: 'white',
                               borderRadius: 2,
                               border: '1px #949494 solid',
                               width: 530,
                               height: 40,
                               margin: '8px 0px',
                           }}
                    />

                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                        marginTop: 22,
                    }}>Client Id
                    </div>
                    <Input value={pacProduct.clientId}
                           onChange={(e) => {
                               setPacProduct({
                                   ...pacProduct, clientId: e.target.value,
                               });
                           }}
                           required={true}
                           style={{
                               background: 'white',
                               borderRadius: 2,
                               border: '1px #949494 solid',
                               width: 530,
                               height: 40,
                               margin: '8px 0px',
                           }}
                    />


                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                        marginTop: 22,
                    }}>Our Private Key {pacProduct.ourPublicKey ? '(Set)' : ''}
                    </div>
                    <Input value={pacProduct.ourPrivateKey}
                           onChange={(e) => {
                               setPacProduct({
                                   ...pacProduct,
                                   ourPrivateKey: e.target.value,
                               });
                           }}
                           placeholder="Leave unchanged if you do not want to change the key"
                           style={{
                               background: 'white',
                               borderRadius: 2,
                               border: '1px #949494 solid',
                               width: 530,
                               height: 40,
                               margin: '8px 0px',
                           }}
                    />

                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 12,
                        marginTop: 22,
                    }}>Our Public Key
                    </div>
                    <Textarea value={pacProduct.ourPublicKey}
                              readonly={true}
                              placeholder="Will not be saved, is generated from the private key"
                              style={{
                                  background: 'white',
                                  color: 'gray',
                                  borderRadius: 2,
                                  border: '1px #949494 solid',
                                  width: 530,
                                  height: 80,
                                  margin: '0px 0px',
                                  padding: '2px',
                              }}
                    />

                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 12,
                        marginTop: 22,
                    }}>Their Public Key
                    </div>
                    <Textarea value={pacProduct.theirPublicKey}
                              onChange={(e) => {
                                  setPacProduct({
                                      ...pacProduct,
                                      theirPublicKey: e.target.value,
                                  });
                              }}
                              placeholder="Leave unchanged if you do not want to change the key"
                              style={{
                                  background: 'white',
                                  borderRadius: 2,
                                  border: '1px #949494 solid',
                                  width: 530,
                                  height: 80,
                                  margin: '0px 0px',
                                  padding: '2px',
                              }}
                    />

                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                        marginTop: 22,
                    }}>Client Secret
                    </div>
                    <Input value={pacProduct.clientSecret}
                           onChange={(e) => {
                               setPacProduct({
                                   ...pacProduct,
                                   clientSecret: e.target.value,
                               });
                           }}
                           placeholder="Leave unchanged if you do not want to change the secret"
                           style={{
                               background: 'white',
                               borderRadius: 2,
                               border: '1px #949494 solid',
                               width: 530,
                               height: 40,
                               margin: '8px 0px',
                           }}
                    />
                </div>

                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    paddingRight: 32,
                    paddingTop: 24,
                    marginTop: 16,
                    paddingBottom: 24,
                    borderTop: '1px solid #E0E0E0'
                }}>

                    <ButtonSecondary
                        onClick={() => {
                            closeModal();
                        }}
                        style={{
                            marginRight: 32,
                        }}>Cancel</ButtonSecondary>

                    <ButtonPrimary
                        type="submit"
                        disabled={saving}
                    >Save</ButtonPrimary>
                </div>
            </form>
        </ModalBase>
    </div>);
}

export default EditPacProductModal;